import { getListIdForFilters } from '../helper';

export const practiceEfectoresActions = {

  FETCH_PRACTICE_EFECTORES_FAILED: 'FETCH_PRACTICE_EFECTORES_FAILED',
  FETCH_PRACTICE_EFECTORES_SUCCESS: 'FETCH_PRACTICE_EFECTORES_SUCCESS',
  FETCH_PRACTICE_EFECTORES_PENDING: 'FETCH_PRACTICE_EFECTORES_PENDING',
  LOAD_PRACTICE_EFECTORES: 'LOAD_PRACTICE_EFECTORES',
  ADD_PRACTICE_EFECTOR: 'ADD_PRACTICE_EFECTOR',

  UPDATE_PRACTICE_EFECTORES_FAILED: 'UPDATE_PRACTICE_EFECTORES_FAILED',
  UPDATE_PRACTICE_EFECTORES_SUCCESS: 'UPDATE_PRACTICE_EFECTORES_SUCCESS',
  UPDATE_PRACTICE_EFECTOR: 'UPDATE_PRACTICE_EFECTOR',

  DELETE_PRACTICE_EFECTORES_FAILED: 'DELETE_PRACTICE_EFECTORES_FAILED',
  DELETE_PRACTICE_EFECTORES_SUCCESS: 'DELETE_PRACTICE_EFECTORES_SUCCESS',
  DELETE_PRACTICE_EFECTOR: 'DELETE_PRACTICE_EFECTOR',

  fetchEfectoresFailed: (error, practiceEfectoresId) => ({
    type: practiceEfectoresActions.FETCH_PRACTICE_EFECTORES_FAILED,
    payload: {
      error,
      practiceEfectoresId
    }
  }),

  fetchEfectoresSuccess: (practiceEfectoresId, {data}) => ({
    type: practiceEfectoresActions.FETCH_PRACTICE_EFECTORES_SUCCESS,
    payload: {
      data,
      practiceEfectoresId
    }
  }),

  fetchEfectoresPending: practiceEfectoresId => ({
    type: practiceEfectoresActions.FETCH_PRACTICE_EFECTORES_PENDING,
    payload: {
      practiceEfectoresId
    }
  }),

  loadEfectores: filters => {
    let new_filters = filters.toJS()
    return ({
      type: practiceEfectoresActions.LOAD_PRACTICE_EFECTORES,
      payload: {
        practiceEfectoresId: getListIdForFilters(new_filters),
        filters: new_filters,
      }
    })
  },

  addEfector: data =>({
    type: practiceEfectoresActions.ADD_PRACTICE_EFECTOR,
    payload: {
      data,
      practiceEfectoresId:  getListIdForFilters({ practiceId: data.practiceId,  sessionId: data.sessionId })
    }
  }),

  updatePracticeEfector: data =>({
    type: practiceEfectoresActions.UPDATE_PRACTICE_EFECTOR,
    payload: {
      data,
      practiceEfectoresId:  getListIdForFilters({ practiceId: data. practicaId,  sessionId: data.sessionId })
    }
  }),

  updatePracticeEfectorFailed: error => ({
    type: practiceEfectoresActions.UPDATE_PRACTICE_EFECTORES_FAILED,
    payload: error
  }),

  updatePracticeEfectorSuccess: (practiceEfectoresId, data) => ({
    type: practiceEfectoresActions.UPDATE_PRACTICE_EFECTORES_SUCCESS,
    payload: {
      data,
      practiceEfectoresId
    }
  }),


  deleteEfector: data =>({
    type: practiceEfectoresActions.DELETE_PRACTICE_EFECTOR,
    payload: {
      data,
      practiceEfectoresId:  getListIdForFilters({ practiceId: data.practicaId,  sessionId: data.sessionId })
    }
  }),

  deleteEfectoresFailed: (error, practiceEfectoresId) => ({
    type: practiceEfectoresActions.DELETE_PRACTICE_EFECTORES_FAILED,
    payload: {
      error,
      practiceEfectoresId
    }
  }),

  deleteEfectoresSuccess: (practiceEfectoresId, data) => ({
    type: practiceEfectoresActions.DELETE_PRACTICE_EFECTORES_SUCCESS,
    payload: {
      data,
      practiceEfectoresId
    }
  }),

};


export const practiceEfectoresRequestActions = {
  failed: practiceEfectoresActions.fetchEfectoresFailed,
  success: practiceEfectoresActions.fetchEfectoresSuccess,
  pending: practiceEfectoresActions.fetchEfectoresPending
};

export const practiceEfectoresDeleteActions = {
  failed: practiceEfectoresActions.deleteEfectoresFailed,
  success: practiceEfectoresActions.deleteEfectoresSuccess,
  pending: practiceEfectoresActions.fetchEfectoresPending
};

export const practiceEfectoresUpdateActions = {
  failed: practiceEfectoresActions.updatePracticeEfectorFailed,
  success: practiceEfectoresActions.updatePracticeEfectorSuccess,
  pending: practiceEfectoresActions.fetchEfectoresPending
};
